import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SER_BASIC_FORM_Schema } from './SER_BASIC_FORM_Schema';

/** 평가표 버전 목록 조회 */
export const useSearchFormList = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SER_BASIC_FORM_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasicR2,
      params
    );
  }, successOptions);
};

/** 평가표 상세 조회 */
export const useSearchFormDetail = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SER_BASIC_FORM_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.getSerBasicR3,
      params
    );
  }, successOptions);
};

/** DRAFT 평가표 열기/생성 */
export const useOpenDraftForm = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      SER_BASIC_FORM_Schema.mapper.openDraft,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.saveSerBasicU1,
      payload
    );
  }, options);
};

/** DRAFT 평가표 저장 */
export const useSaveForm = (options = {}) => {
  return useSaveMutation(async (input) => {
    let rows = [];
    let context = {};

    if (Array.isArray(input)) {
      rows = input;
    } else if (input?.rows) {
      rows = Array.isArray(input.rows) ? input.rows : [input.rows];
      context = input.context ?? {};
    } else if (input && typeof input === 'object') {
      rows = [input];
    }

    const firstRow = rows?.[0];
    const payload =
      mapRowsBySchema(
        firstRow ? [firstRow] : [],
        SER_BASIC_FORM_Schema.mapper.save1,
        context
      )?.[0] ?? {};
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.saveSerBasicU2,
      payload
    );
  }, options);
};

/** DRAFT 평가표 배포 */
export const usePublishForm = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      SER_BASIC_FORM_Schema.mapper.publish1,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.saveSerBasicU3,
      payload
    );
  }, options);
};

/** DRAFT 평가표 양식 삭제 */
export const useDeleteForm = (options = {}) => {
  return useDeleteMutation(async (context) => {
    const payload =
      mapRowsBySchema(
        [context],
        SER_BASIC_FORM_Schema.mapper.delete1,
        context
      )?.[0] ?? {};
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.deleteSerBasicD2,
      payload,
      { suppressGlobalError: true }
    );
  }, options);
};
